function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useElements, useStripe } from '@stripe/react-stripe-js';
import { Formik } from 'formik';
import { first } from 'lodash';
import isEmpty from 'lodash/isEmpty';
import noop from 'lodash/noop';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { listUserCards, setDiscountCode } from '../../../redux/actions';
import routes from '../../../routes/constants';
import text from '../../../text';
import Accordion from '../../accordion/Accordion';
import Button from '../../button/Button';
import CardOption from '../../card/CardOption';
import NewCard from '../../card/NewCard';
import Loading from '../../loading/Loading';
import TextDivider from '../../text/TextDivider';
import FormFooter from '../FormFooter';
import Control from '../Control';
var PaymentMethodForm = function(param) {
    var _param_onAddCard = param.onAddCard, onAddCard = _param_onAddCard === void 0 ? noop : _param_onAddCard, _param_onPaymentMethodChange = param.onPaymentMethodChange, onPaymentMethodChange = _param_onPaymentMethodChange === void 0 ? noop : _param_onPaymentMethodChange;
    var jobId = useParams().jobId;
    var stripe = useStripe();
    var elements = useElements();
    var _useState = _sliced_to_array(useState(false), 2), isSubmitting = _useState[0], setIsSubmitting = _useState[1];
    var _useState1 = _sliced_to_array(useState(), 2), paymentError = _useState1[0], setPaymentError = _useState1[1];
    var _useState2 = _sliced_to_array(useState(), 2), isNewCardDetailsComplete = _useState2[0], setIsNewCardDetailsComplete = _useState2[1];
    var _useState3 = _sliced_to_array(useState(), 2), currentEventKey = _useState3[0], setCurrentEventKey = _useState3[1];
    var dispatch = useDispatch();
    var returnPage = routes.payment.job(jobId);
    var returnUrl = "".concat(process.env.LARKI_APP_URL).concat(returnPage);
    var _useSelector = useSelector(function(state) {
        var _state_profileReducer_userCards_value_find, _state_profileReducer_userCards_value, _first;
        return {
            job: state.jobsReducer.job,
            discountCode: state.order.discountCode,
            userProfile: state.profileReducer.userProfile,
            userCards: state.profileReducer.userCards,
            defaultCardId: ((_state_profileReducer_userCards_value = state.profileReducer.userCards.value) === null || _state_profileReducer_userCards_value === void 0 ? void 0 : (_state_profileReducer_userCards_value_find = _state_profileReducer_userCards_value.find(function(card) {
                return card.default_payment_method;
            })) === null || _state_profileReducer_userCards_value_find === void 0 ? void 0 : _state_profileReducer_userCards_value_find.id) || ((_first = first(state.profileReducer.userCards.value)) === null || _first === void 0 ? void 0 : _first.id)
        };
    }), userProfile = _useSelector.userProfile, discountCode = _useSelector.discountCode, userCards = _useSelector.userCards, defaultCardId = _useSelector.defaultCardId;
    var isStripeLoading = !stripe || !elements;
    var handleSubmit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(values) {
            var _ref, setupIntent, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // We don't want to let default form submission happen here,
                        // which would refresh the page.
                        if (isStripeLoading) {
                            return [
                                2
                            ];
                        }
                        setIsSubmitting(true);
                        return [
                            4,
                            stripe.confirmSetup({
                                elements: elements,
                                confirmParams: {
                                    payment_method_data: {
                                        billing_details: {
                                            address: {
                                                country: 'au'
                                            },
                                            name: values.name
                                        }
                                    },
                                    return_url: returnUrl
                                },
                                redirect: 'if_required'
                            })
                        ];
                    case 1:
                        _ref = _state.sent(), setupIntent = _ref.setupIntent, error = _ref.error;
                        if (error) {
                            setPaymentError(error);
                            setIsSubmitting(false);
                        }
                        onPaymentMethodChange(setupIntent.payment_method);
                        onAddCard();
                        setIsSubmitting(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    useEffect(function() {
        dispatch(listUserCards());
    }, []);
    useEffect(function() {
        var _userCards_value_;
        if (userCards.value && ((_userCards_value_ = userCards.value[0]) === null || _userCards_value_ === void 0 ? void 0 : _userCards_value_.id)) {
            var _userCards_value_1;
            onPaymentMethodChange((_userCards_value_1 = userCards.value[0]) === null || _userCards_value_1 === void 0 ? void 0 : _userCards_value_1.id);
        }
    }, [
        userCards
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "PaymentMethodForm"
    }, /*#__PURE__*/ React.createElement(Formik, {
        enableReinitialize: true,
        initialValues: {
            savedCardId: defaultCardId,
            name: userProfile.full_name,
            saveCard: true
        }
    }, function(param) {
        var values = param.values, handleChange = param.handleChange, setFieldValue = param.setFieldValue;
        var _userCards_value;
        var handleAccordionToggle = function(eventKey) {
            setCurrentEventKey(eventKey);
            setFieldValue('savedCardId', null);
            onPaymentMethodChange();
        };
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h4", {
            className: "green-1"
        }, text('payByCard')), !userCards.isLoading ? !isEmpty(userCards.value) && /*#__PURE__*/ React.createElement("div", null, (_userCards_value = userCards.value) === null || _userCards_value === void 0 ? void 0 : _userCards_value.map(function(card, i) {
            return /*#__PURE__*/ React.createElement(CardOption, {
                key: i,
                name: "savedCardId",
                listCards: function() {
                    return dispatch(listUserCards());
                },
                onChange: function(v) {
                    setCurrentEventKey();
                    onPaymentMethodChange(v === null || v === void 0 ? void 0 : v.target.value);
                    handleChange(v);
                },
                card: card,
                isSelected: card.id === values.savedCardId
            });
        }), /*#__PURE__*/ React.createElement(TextDivider, {
            isSecondary: true
        }, text('or'))) : /*#__PURE__*/ React.createElement(Loading, null), !userCards.isLoading && /*#__PURE__*/ React.createElement(Accordion, {
            defaultActiveKey: isEmpty(userCards.value) ? 'newCard' : null,
            activeKey: currentEventKey
        }, /*#__PURE__*/ React.createElement(Accordion.Card, {
            toggleLabel: text('addNewCard'),
            eventKey: "newCard",
            onToggle: handleAccordionToggle
        }, /*#__PURE__*/ React.createElement(NewCard, {
            onChange: handleChange,
            onPaymentElementChange: setIsNewCardDetailsComplete,
            name: "name",
            value: values.name,
            label: text('nameOnCard'),
            isFailed: (paymentError === null || paymentError === void 0 ? void 0 : paymentError.code) === 'incomplete_name',
            error: (paymentError === null || paymentError === void 0 ? void 0 : paymentError.code) === 'incomplete_name' ? paymentError.message : ''
        }), /*#__PURE__*/ React.createElement(FormFooter, null, /*#__PURE__*/ React.createElement(Button, {
            onClick: function() {
                return handleSubmit(values);
            },
            variant: "outline-primary",
            loading: isSubmitting,
            disabled: isStripeLoading || !isNewCardDetailsComplete
        }, text('addCard'))))), /*#__PURE__*/ React.createElement("div", {
            className: "paymentError"
        }, paymentError === null || paymentError === void 0 ? void 0 : paymentError.message), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Control, {
            placeholder: "PROMO_CODE",
            isInputWidthAuto: true,
            as: "input",
            type: "text",
            place: true,
            value: discountCode,
            className: "w-auto",
            onChange: function(event) {
                return dispatch(setDiscountCode(event.target.value));
            },
            label: text('enterYourPromotionCode')
        })));
    }));
};
export default PaymentMethodForm;
